<template>
  <div class="container-fluid first-view">
    <div class="background-overlay"/>
    <img class="logo" :src="logo"/>
    <Loader :show="loadingData" v-if="loadingData" style="z-index: 5"/>
    <div v-else class="bg-animate fadeIn card view-wrapper">
      <div class="card-body view">
        <div class="header">
          <div class="title">
            <div>Find Study</div>
          </div>
        </div>
        <div class="form-wrapper mt-4">
          <div class="d-flex flex-column justify-content-center w-100">
            <div class="form-group d-flex flex-wrap justify-content-center">
              <div v-for="field in formDataField" :key="field.model">
                <el-select
                  v-model="searchFilters.essentials[field.model].value"
                  class="select-group-item"
                  :placeholder="field.placeholder"
                  multiple
                  fulterable
                  collapse-tags
                  @change="updateDropdownValues(field.model === 'region')"
                >
                  <el-option-group label="Press Tab/Escape to exit">
                    <el-option
                      v-for="option in parsedFields[field.name]"
                      :key="option[0]"
                      :label="option[0]"
                      :value="option[0]"
                    >
                      <span style="float: left">{{ option[0] }}</span>
                      <span style="float: right; color: #8492a6; font-size: 13px">{{ option[1] }}</span>
                    </el-option>
                  </el-option-group>
                </el-select>
              </div>
            </div>
            <template v-if="yearsObject && formData.year.length === 2">
              <div class="row d-flex justify-content-center" style="align-items: center; margin-top: 20px">
                <div class="col-lg-4 col-md-4 input-wrapper">
                  <div class="slider-wrapper">
                    <el-slider
                      v-model="formData.year"
                      range
                      :min="yearsObject.min"
                      :max="yearsObject.max"
                      :marks="yearsObject.marks"
                      show-stops
                      @change="parseYears()"
                    />
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div>
          <div class="d-flex justify-content-end mt-4">
            <router-link
              :to="{name: 'search', params: {startSearch: true, hideDescription: true, header: 'Confirm your selections:'}}"
            >
              <button class="btn next-button" @click="search">Search</button>
            </router-link>
          </div>
          <div class="footnote"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions, mapGetters } from 'vuex'
import searchFunctions from '../../helpers/searchFunctions'
import studiesActions from '../../store/modules/studies/actionTypes'
import generalGetters from '../../store/modules/general/getterTypes'
import getInitialFilters from '../../constants/searchFilters'
import Loader from '@/components/shared/Loader'
import logo from '@/assets/images/logos/Iris-Grey.svg'

export default {
  name: 'RDFSearch',
  components: {
    Loader
  },
  data () {
    return {
      logo,
      loadingData: true,
      yearsObject: {},
      formData: {
        year: []
      },
      parsedFields: {},
      searchFilters: {},
      formDataField: [
        { name: 'Client', placeholder: 'Select client', model: 'client' },
        { name: 'Region', placeholder: 'Select region of the study', model: 'region' },
        {
          name: 'Business Unit',
          placeholder: 'Select business unit',
          model: 'businessUnit'
        },
        { name: 'Category', placeholder: 'Select category', model: 'category' },
        { name: 'Product', placeholder: 'Select product', model: 'product' }
      ]
    }
  },
  computed: {
    ...mapGetters({
      alertMessage: generalGetters.GET_ALERT_MESSAGE,
      alertType: generalGetters.GET_ALERT_TYPE
    })
  },
  methods: {
    ...mapActions({
      updateMetricsOptions: studiesActions.UPDATE_METRICS_DROPDOWN_OPTIONS,
      setOrClearFilters: studiesActions.SET_OR_CLEAR_SEARCH_FILTERS
    }),
    parseFields (fields) {
      const seekingFields = ['Business Unit', 'Category', 'Client', 'Product Type', 'Region', 'Year']
      const collectedFields = {}

      const data = fields[0]['data']
      for (let i = 0; i < data.length; ++i) {
        if (seekingFields.includes(data[i].label)) {
          if (data[i].type === 'category') {
            const options = []
            for (let j = 0; j < data[i].options.length; ++j) {
              let { count, value } = data[i].options[j]
              if (data[i].label === 'Year') value = parseInt(value)
              options.push([value, count])
            }

            collectedFields[data[i].label] = options
          }
        }
      }
      this.parsedFields = collectedFields
    },
    parseYears () {
      this.searchFilters.essentials.startYear.value = this.formData.year[0]
      this.searchFilters.essentials.endYear.value = this.formData.year[1]
      this.updateDropdownValues(true)
    },
    setFilters () {
      this.formData.rdfType = 'rdf'
      this.formData.radioDesc = 'best'
      this.formData.radioPercentType = 'number'
      this.$set(this.searchFilters.metrics.threshold, 'type', 'fragrances')
      this.$set(this.searchFilters.metrics.metricsList[0].aggregation, 'value', 'top_2_box')
      this.$set(this.searchFilters.metrics.rdfType, 'value', this.formData.rdfType)
      this.$set(this.searchFilters.metrics.threshold, 'desc', true)
      this.$set(this.searchFilters.metrics.threshold, 'applyThreshold', true)
      this.$set(this.searchFilters.metrics.metricsList[0].metricType, 'value', 'Performance')
      this.$set(this.searchFilters.metrics.metricsList[0].metric, 'value', 'liking')
    },
    async updateDropdownValues (shouldUpdate = false) {
      if (this.formData && shouldUpdate) {
        const data = searchFunctions.parseDataForSearch(_.cloneDeep(this.searchFilters))
        const parsedQuery = data.query
        const res = await this.updateMetricsOptions({ query: parsedQuery, query_metrics: [] })
        this.parseFields(res.data.fields)
      }
    },
    async getFields () {
      this.loadingData = true
      const analyticFields = (await this.updateMetricsOptions({ query: [], query_metrics: [] })).data.fields
      this.parseFields(analyticFields)
      const years = [...this.parsedFields['Year']]
      const [firstYear, lastYear] = [years[0][0], years[years.length - 1][0]]
      this.formData.year = [firstYear, lastYear]
      this.yearsObject = {
        min: firstYear,
        max: lastYear,
        marks: { [firstYear]: String(firstYear), [lastYear]: String(lastYear) }
      }

      this.searchFilters = _.cloneDeep(getInitialFilters.getInitialFilters())
      this.loadingData = false
    },
    async search () {
      if (this.formData) {
        this.setFilters()
        this.setOrClearFilters({ 'clearFilters': false, filters: this.searchFilters })
      }
    }
  },
  async mounted () {
    await this.getFields()
  }
}
</script>

<style lang="scss">
@import "../../assets/scss/variables";

.select-group-item {
  margin: 5px;
  width: 100% !important;
  max-width: 300px;

  .el-input__inner {
    font-family: 'Helvetica', sans-serif;
    font-size: 13px;
    line-height: 20px;
    letter-spacing: 0;
    color: $default-focus;
    background-color: white !important;
    border: 2px solid #EBEDED !important;
    border-radius: 6px;
  }
}
</style>

<style lang="scss" scoped>
@import "../../assets/scss/variables";

.container-fluid.first-view {
  padding: 99px 87px !important;
  background-image: url("../../assets/images/backgrounds/IRIS-background-720p.jpg");
  background-position: center;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  .background-overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #2a274b;
    opacity: 0.4;
  }
}

.logo {
  position: fixed;
  bottom: 60px;
  right: 25px;
  max-width: 300px;
  min-width: 120px;
  max-height: 300px;
  min-height: 120px;
  width: 10%;
  height: auto;
}
@media (max-height: 980px) {
  .logo {
    bottom: 40px;
    right: 15px;
    width: 6%;
  }
}

.container-fluid {
  height: 100%;
}

hr.space {
  margin: 1.5em 0;
  visibility: hidden;
}

.view-wrapper {
  margin-bottom: 0;
  width: 100%;
  max-width: 1300px;
  background-color: rgba(255, 255, 255, 0.93);
  border: 0;
}

.view {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  box-shadow: 0 3px 6px #000000;
  padding: 0;

  .header {
    display: flex;
    justify-content: space-between;
  }

  .form-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    color: $dusty-blue;

    .subtitle {
      @media screen and (min-width: $break-lg) {
        font-size: 25px;
        line-height: 45px;
      }
      @media screen and (min-width: $break-xl) {
        font-size: 30px;
        line-height: 50px;
      }
      @media screen and (min-width: $break-xxl) {
        font-size: 35px;
        line-height: 55px;
      }
      text-align: center;
      font-family: 'Source Sans Pro', sans-serif;
      font-weight: 600;
      font-size: 35px;
      line-height: 55px;
      letter-spacing: 0;
      color: $dusty-blue;
    }

    .form-group {
      @media screen and (min-width: $break-lg) {
        padding: 0 12px;
        margin-top: 5px;
      }
      @media screen and (min-width: $break-xl) {
        padding: 0 32px;
        margin-top: 15px;
      }
      @media screen and (min-width: $break-xxl) {
        padding: 0 98px;
        margin-top: 35px;
      }
      text-align: center;
    }

    .select-group-item {
      @media screen and (min-width: $break-lg) {
        margin: 3px 3px;
        width: 45%;
      }
      @media screen and (min-width: $break-xl) {
        margin: 5px 5px;
        width: 35%;
      }
      @media screen and (min-width: $break-xxl) {
        margin: 5px 10px;
        width: 30%;
      }
    }
  }

  .next-button {
    width: 240px;
    height: 48px;
    font-family: 'Open Sans', sans-serif;
    font-weight: 900;
    font-size: 16px;
    line-height: 30px;
    letter-spacing: 0;
    background: #300296;
    color: white;
    text-transform: uppercase;
    border-radius: 4px;
    margin-right: 40px;
    margin-bottom: 15px;
    @media screen and (min-width: $break-lg) {
      margin-right: 55px;
      margin-bottom: 20px;
    }
    @media screen and (min-width: $break-xl) {
      margin-right: 75px;
      margin-bottom: 25px;
    }
    @media screen and (min-width: $break-xxl) {
      margin-right: 100px;
      margin-bottom: 35px;
    }

    transition: background-color 0.2s linear;

    &:hover {
      background-color: #9256D9;
    }
  }
}

.title {
  margin-top: 20px;
  margin-left: 32px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  font-family: 'Source Sans Pro', sans-serif;
  font-weight: 900;
  color: $pewter;
  text-transform: uppercase;
  font-size: 30px;
  line-height: 24px;
  letter-spacing: 0.8px;
  @media screen and (min-width: $break-lg) {
    font-size: 35px;
    line-height: 26px;
    letter-spacing: 0.8px;
    margin-top: 23px;
    margin-left: 37px;
  }
  @media screen and (min-width: $break-xl) {
    font-size: 40px;
    line-height: 28px;
    letter-spacing: 0.9px;
    margin-top: 26px;
    margin-left: 42px;
  }
  @media screen and (min-width: $break-xxl) {
    font-size: 45px;
    line-height: 30px;
    letter-spacing: 0.9px;
    margin-top: 29px;
    margin-left: 47px;
  }
}

.footnote {
  height: 44px;
  background: transparent linear-gradient(268deg, #C961C5 0%, #DEBFDD 100%) 0% 0% no-repeat padding-box;
  box-shadow: 0 3px 6px #00000029;
  opacity: 0.9;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  @media screen and (min-width: $break-lg) {
    height: 49px;
    span {
      font-size: 18px;
      line-height: 20px;
      margin-right: 50px;
    }
  }
  @media screen and (min-width: $break-xl) {
    height: 54px;
    span {
      font-size: 18px;
      line-height: 22px;
      margin-right: 55px;
    }
  }
  @media screen and (min-width: $break-xxl) {
    height: 59px;
    span {
      font-size: 20px;
      line-height: 25px;
      margin-right: 60px;
    }
  }

  span {
    font-family: 'Source Sans Pro', sans-serif;
    font-size: 16px;
    line-height: 18px;
    color: $charcoal;
    margin-right: 45px;
  }
}

.title svg {
  margin-right: 0.5em;
}
</style>
